var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BasePopup', {
    attrs: {
      "show": _vm.show,
      "show-close-button": false,
      "auto-close": 3000
    },
    on: {
      "close": function close($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "success-popup-content"
  }, [_c('div', {
    staticClass: "success-icon"
  }, [_c('svg', {
    attrs: {
      "width": "60",
      "height": "43",
      "viewBox": "0 0 60 43",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M56.6667 3L20 39.6667L3.33337 23",
      "stroke": "#FE577F",
      "stroke-width": "5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _c('div', {
    staticClass: "popup-title"
  }, [_vm._v(_vm._s(_vm.message))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }